runOnLoad "SpecialSendingRules", ["new", "create", "edit", "update"], ->

  $language = $("#special_sending_rule_evaluator_name")
  $editor = $("#special_sending_rule_code")

  if $editor.length > 0

    # Adjust syntax highlighting.

    $editor.ace()

    ace = $editor.data('ace').editor.ace
    ace.setShowPrintMargin(false)
    ace.setTheme('ace/theme/xcode')
    ace.getSession().setUseWorker(false)

    setSyntaxHighlighting = ->
      switch $language.val()
        when "perl" then ace.getSession().setMode('ace/mode/perl')
        when "php"  then ace.getSession().setMode(path: 'ace/mode/php', inline: true)

    $language.on("change", setSyntaxHighlighting)
    setSyntaxHighlighting()

    # Load default template.

    $language.on "change", ->
      languageIdentifier = $language.val()
      languageLabel      = t("special_sending_rule_evaluators.#{ languageIdentifier }")
      askToChange        = t("special_sending_rule_templates.ask_to_change", language: languageLabel)
      codeTemplate       = t("special_sending_rule_templates.#{ languageIdentifier }")
      Dialogs.presentYesNoModal askToChange, {}, -> ace.setValue(codeTemplate, 1)
      return true

runOnLoad "SpecialSendingRules", "preview", ->

  $('#preview_organization').on 'change', ->
    location.href = location.pathname + '?organization='+$(this).val()

  $('#preview_campaign').on 'change', ->
    location.href = location.pathname +
      '?organization=' + $('#preview_organization').val() +
      '&campaign=' + $(this).val()

runOnLoad "Previews", [ "new", "create" ], ->

  specialSendingRuleId      = $("#special_sending_rule_preview_special_sending_rule_id").val()
  $ssrPreviewOrganizationId = $("#special_sending_rule_preview_organization_id")

  # Update the campaign dropdown when the organization dropdown changes.
  $ssrPreviewOrganizationId.on "change", ->
    organizationId = $ssrPreviewOrganizationId.val()
    $.get Routes.campaign_form_field_special_sending_rule_previews_path(specialSendingRuleId, organization_id: organizationId), (html) ->
      formFieldSelector = ".form-field.special_sending_rule_preview_campaign_id"
      $(formFieldSelector).replaceWith(html)
      UI.setupSelects($(formFieldSelector))

  # Update the subscriber section when the campaign changes.
  $(document).on "change", "#special_sending_rule_preview_campaign_id", ->
    campaignId = $(@).val()
    email = $("#special_sending_rule_preview_subscriber_attributes_email").val()
    $.get Routes.subscriber_form_fields_special_sending_rule_previews_path(specialSendingRuleId, campaign_id: campaignId, email: email), (html) ->
      formFieldSelector = ".form-section-container.subscriber ul.form-fields"
      $(formFieldSelector).html(html)
      UI.setupSelects($(formFieldSelector))
